import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, systemConfigsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, systemConfigsActions);

export default slice.reducer;
